function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Pagination from 'react-bootstrap/Pagination';
import { useGrid } from '../hook';

const PaginationAlgo = ({
  className,
  size,
  nextProps,
  prevProps,
  firstProps,
  lastProps,
  pageProps,
  activeProps,
  ellipsisProps
}) => {
  const {
    page,
    query,
    perPage,
    paginateProps
  } = useGrid();
  const totalPages = Math.ceil(query.totalCount / perPage);
  const pageFirstSideStart = page - 2;
  const pageLastSideStart = page + 1;
  const pageFirstSideStartIsMoreThanOne = pageFirstSideStart > 1;
  const pageLastSideEndIsLessThanTotalPage = page + 2 < totalPages;
  const pageIsOne = page === 1 || totalPages === 0;
  const pageIsTotalPage = page === totalPages || totalPages === 0;
  const totalPageIsLessThanTen = totalPages < 10;
  const addExcessInFirstSideStart = Math.max(0, page - (totalPages - 4));
  const addExcessInLastSideStart = Math.max(0, 5 - page);

  const ListBuilder = ({
    total,
    start,
    currentPage
  }) => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, new Array(total).fill(0).map((v, index) => {
      const final = start + index;
      const isActive = currentPage && currentPage === final;
      return /*#__PURE__*/React.createElement(Pagination.Item, _extends({
        key: final,
        children: final,
        active: isActive
      }, pageProps, paginateProps(final)));
    }));
  };

  return /*#__PURE__*/React.createElement(Pagination, {
    size: size,
    className: className
  }, /*#__PURE__*/React.createElement(Pagination.First, _extends({
    disabled: pageIsOne,
    "data-action-type": "page-leaper"
  }, firstProps, paginateProps(1))), /*#__PURE__*/React.createElement(Pagination.Prev, _extends({
    disabled: pageIsOne,
    "data-action-type": "page-leaper"
  }, prevProps, paginateProps(Math.max(1, page - 1)))), totalPageIsLessThanTen ? /*#__PURE__*/React.createElement(ListBuilder, {
    total: totalPages,
    start: 1,
    currentPage: page
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, pageFirstSideStartIsMoreThanOne && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Pagination.Item, _extends({
    children: 1
  }, pageProps, paginateProps(1))), pageFirstSideStart > 2 && /*#__PURE__*/React.createElement(Pagination.Ellipsis, _extends({
    title: "Previous 5 Pages"
  }, ellipsisProps, paginateProps(Math.max(2, page - 5))))), pageIsOne || /*#__PURE__*/React.createElement(ListBuilder, {
    total: page > 2 ? 2 + addExcessInFirstSideStart : 1,
    start: Math.max(1, pageFirstSideStart - addExcessInFirstSideStart),
    currentPage: page
  }), /*#__PURE__*/React.createElement(Pagination.Item, _extends({
    children: page
  }, activeProps, {
    active: true,
    onClick: e => e.preventDefault()
  })), pageIsTotalPage || /*#__PURE__*/React.createElement(ListBuilder, {
    total: page < totalPages - 1 ? 2 + addExcessInLastSideStart : 1,
    start: pageLastSideStart,
    currentPage: page
  }), pageLastSideEndIsLessThanTotalPage && /*#__PURE__*/React.createElement(React.Fragment, null, pageLastSideStart < totalPages - 2 && /*#__PURE__*/React.createElement(Pagination.Ellipsis, _extends({
    title: "Next 5 Pages"
  }, ellipsisProps, paginateProps(Math.min(totalPages - 1, page + 5)))), /*#__PURE__*/React.createElement(Pagination.Item, _extends({
    children: totalPages
  }, pageProps, paginateProps(totalPages))))), /*#__PURE__*/React.createElement(Pagination.Next, _extends({
    disabled: pageIsTotalPage,
    "data-action-type": "page-leaper"
  }, nextProps, paginateProps(Math.min(totalPages, page + 1)))), /*#__PURE__*/React.createElement(Pagination.Last, _extends({
    disabled: pageIsTotalPage,
    "data-action-type": "page-leaper"
  }, lastProps, paginateProps(totalPages))));
};

export default PaginationAlgo;